import { render, staticRenderFns } from "./languageSelector.vue?vue&type=template&id=7ba934ab"
import script from "./languageSelector.vue?vue&type=script&lang=js"
export * from "./languageSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports